module.exports = __webpack_public_path__ + "img/logout.bcc3448c.svg";